import { defineStore } from 'pinia'
import axios from 'axios'
import { environment } from '@/environments/environment'

interface ResourceState {
  icons: Record<string, string>
  banners: Record<string, string>
  sports: Record<string, string>
  loading: boolean
  error: string | null
}

const client = axios.create({
  baseURL: `${environment.API_CLIENT}`,
  withCredentials: true,
})

export const useResourcesStore = defineStore('resources', {
  state: (): ResourceState => ({
    icons: {},
    banners: {},
    sports: {},
    loading: false,
    error: null,
  }),

  actions: {
    async loadResources() {
      this.loading = true
      this.error = null

      try {
        const [iconsRes, bannersRes, sportsRes] = await Promise.all([
          client.get<Record<string, string>>('/resources/icons'),
          client.get<Record<string, string>>('/resources/banners'),
					client.get<Record<string, string>>('/resources/sports'),
        ])

        this.icons = iconsRes.data || {}
        this.banners = bannersRes.data || {}
        this.sports = sportsRes.data || {}

      } catch (err: any) {
        console.error('Failed to load resources:', err)
        this.error = err.message || 'Failed to load resources'
      } finally {
        this.loading = false
      }
    },

    getIconSvg(filename: string): string | undefined {
      return this.icons[filename]
    },

    getBannerSvg(filename: string): string | undefined {
      return this.banners[filename]
    },

		getSportSvg(filename: string): string | undefined {
			return this.sports[filename]
		},
  },
})